<app-page-header title="function.Settings" translateTitle="yes" icon="settings"></app-page-header>

<div [@fadeInOut] class="page-content">

  <mat-accordion class="accordion-headers-align">
    <mat-expansion-panel #profile hideToggle="true" (opened)="navigateToFragment('profile')">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{'settings.tab.Profile' | translate}}
        </mat-panel-title>
        <mat-panel-description>
          {{'settings.description.UserProfile' | translate}}
          <mat-icon>account_circle</mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>

      <user-editor #userProfile></user-editor>

      <mat-action-row>
        @if (!userProfile.isEditMode) {
          <button mat-raised-button (click)="userProfile.beginEdit()" color="primary">{{ 'commands.Edit' | translate }}</button>
        }
        @if (userProfile.isEditMode) {
          <button mat-raised-button (click)="userProfile.save()" color="primary" style="margin-right: 1em;">{{ 'commands.Save' | translate }}</button>
        }
        @if (userProfile.isEditMode) {
          <button mat-raised-button (click)="userProfile.cancel()" color="warn">{{ 'commands.Cancel' | translate }}</button>
        }
      </mat-action-row>

    </mat-expansion-panel>

  </mat-accordion>

</div>
